import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ACCESS_REQUEST_STATUS_CARD_MODEL, FILE_MODEL } from "../Model/Model";
import { GetRequestAccessAssets } from "../../../../../reduxToolkit/RequestAccess/RequestAccessApi";

/**
 * @Email    : kpozos@ibl.mx
 * @Author   : Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 *
 * @component RequestAccessModalApp
 * @description Fetches and manages the assets and status for a selected access request invitation.
 * Updates state whenever a new invitation item is selected.
 *
 * @param {Object} props
 * @param {Object} props.itemSelected - The currently selected invitation item to display details for.
 *
 * @returns {Object} Exposes the translation function, current request status, and associated assets.
 */
export const RequestAccessModalApp = ({ itemSelected }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [requestStatus, setRequestStatus] = useState(null); // Stores the current request's status
    const [assets, setAssets] = useState([]); // Stores associated files/assets

    useEffect(() => {
        if (itemSelected) {
            // Fetch assets related to the selected invitation
            dispatch(GetRequestAccessAssets(itemSelected.id))
                .then(({ payload: { data: { data } } }) => {
                    const aux = data.map(e => FILE_MODEL.set(e));
                    setAssets(aux);
                });

            // Set the request status based on the selected invitation
            setRequestStatus(
                ACCESS_REQUEST_STATUS_CARD_MODEL.getAccessRequestStatus(itemSelected.statusId)
            );
        }
    }, [itemSelected]);

    return {
        t,
        requestStatus,
        assets
    };
};
